// ajax 请求，axios 总是不能调通
export default function ajax(options) {
  var xhr = null
  //创建对象
  if (window.XMLHttpRequest) {
    xhr = new XMLHttpRequest()
  } else {
    xhr = new ActiveXObject('Microsoft.XMLHTTP')
  }
  var formsParams = function (data) {
    var arr = []
    for (var prop in data) {
      arr.push(prop + '=' + encodeURIComponent(data[prop]))
    }
    return arr.join('&')
  }
  var params = formsParams(options.data)
  // 连接
  if (options.type.toLowerCase() == 'get') {
    xhr.open(options.type, options.url + '?' + params, true)
    xhr.send(null)
  } else if (options.type.toLowerCase() == 'post') {
    xhr.open(options.type, options.url, true)
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8')
    xhr.send(params)
  }
  // 返回Promise结果
  return new Promise((resolve, reject) => {
    ;(xhr.onreadystatechange = function () {
      if (xhr.readyState == 4 && xhr.status == 200) {
        var res = null
        try {
          res = JSON.parse(xhr.responseText)
        } catch (err) {
          res = xhr.responseText
        }
        if (options.success) options.success(res)
        resolve(res)
      }
    }),
      (xhr.onerror = function (err) {
        reject(err)
      })
  })
}
